import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SubscriberInfo } from 'src/app/admin-api';
import { EditionId, SubscriptionEnum } from 'src/app/models';

@Component({
  selector: 'app-subscriber-card',
  templateUrl: './subscriber-card.component.html',
  styleUrls: ['./subscriber-card.component.scss']
})
export class SubscriberCardComponent implements OnInit {
  @Input()
  subscriber: SubscriberInfo | undefined;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.subscriber = {
      ...this.subscriber,
      subscriptionTypeName: this.subscriber?.subscriptionTypeName?.replace(
        'Anual.',
        'Anual/mês'
      )
    };
  }

  goToSubscriber(): void {
    this.router.navigate([
      'users/subscribers/' + this.subscriber?.subscriberId
    ]);
  }

  get editionAsDate(): Date {
    return this.subscriber?.startEdition
      ? new Date(
          EditionId.year(this.subscriber.startEdition) +
            '-' +
            EditionId.month(this.subscriber.startEdition)
              .toFixed(0)
              .padStart(2, '0') +
            '-01 12:00:00'
        )
      : new Date();
  }

  get endOfCycleDate(): Date {
    if (!this.subscriber?.nextCycleDate) return null;
    const next = new Date(this.subscriber.nextCycleDate);
    next.setMonth(next.getMonth() - 1);
    return next;
  }

  get cardHeaderClass() {
    switch (this.subscriber?.subscriptionId) {
      case SubscriptionEnum.Glambag:
      case SubscriptionEnum['Glambag Premium']:
        return 'card-header--bag';
      case SubscriptionEnum.Glamcombo:
      case SubscriptionEnum['Glamcombo Premium']:
        return 'card-header--combo';
      case SubscriptionEnum.Select:
        return 'card-header--select';
      case SubscriptionEnum.Glampass:
        return 'card-header--pass';
      case SubscriptionEnum.Prime:
        return 'card-header--prime';
      default:
        return '';
    }
  }

  get paymentMethod() {
    return this.subscriber?.paymentMethod &&
      this.subscriber?.paymentMethod === 'PIX'
      ? 'Pix automático'
      : 'Cartão de crédito';
  }
}
